import {useAppDispatch} from "../../../store/hooks";
import {useMarkDocumentHandled} from "../../../api/DocumentApi";
import {addToast} from "../../../store/slices/uiSlice";
import {toastInfo} from "../../../core/helpers/toastHelper";
import {CustomDropdownItem} from "../../../components/CustomDropdown/CustomDropdownItem/CustomDropdownItem";
import {Icon} from "../../../assets/Icons/IconClassNames";
import {IDocument} from "../../../core/interfaces/document";

interface IMarkAsImportantHandled {
    document: IDocument;
    disabled: boolean;
    isEditMode: boolean;
}

const MarkAsImportantHandled = (
    {
        document,
        disabled,
        isEditMode,
    }: IMarkAsImportantHandled) => {
    const dispatch = useAppDispatch();
    const [request, isLoading] = useMarkDocumentHandled(document.id);

    const handleRequest = async () => {
        if (isEditMode) {
            dispatch(addToast(toastInfo("Lämna redigeringsläge", "Vänligen lämna redigeringsläget.")));
            return;
        }
        await request(document.importantHandledAt === undefined || document.importantHandledAt === null);
    }
    return <CustomDropdownItem
        disabled={disabled || isLoading}
        icon={Icon.CIRCLE}
        iconColor={"green"}
        text={`${document.importantHandledAt ? 'Avmarkera' : 'Markera'} som hanterad`}
        onClick={handleRequest}
    />
};

export default MarkAsImportantHandled;